import { render, staticRenderFns } from "./OrderItemMediaAttachment.vue?vue&type=template&id=d99b5458"
import script from "./OrderItemMediaAttachment.vue?vue&type=script&lang=js"
export * from "./OrderItemMediaAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports